export default __webpack_public_path__ + "73e84ecf138c39fb2c97167a5f9e82a2.webp";